import { createBrowserInspector } from '@statelyai/inspect';

export let xstateInspect: ReturnType<typeof createBrowserInspector>['inspect'] | undefined;

if (typeof window !== 'undefined' && injectedEnv.REACT_APP_SHOW_XSTATE_INSPECTOR === 'true') {
  const inspector = createBrowserInspector();
  xstateInspect = inspector.inspect;
}
